var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"moveView",staticClass:"move-view",on:{"mousedown":_vm.downRP,"touchstart":_vm.downRP,"mousemove":_vm.moveRP,"touchmove":_vm.moveRP,"mouseleave":_vm.moveRP,"mouseover":_vm.endRP,"mouseup":_vm.endRP,"touchend":_vm.endRP}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }